import React from "react"
import badge from "badges/first-column-badge-blocked.svg"
import { BadgeImage } from "backpack/badges/styled"

const FirstColumnBadgeBlocked = props => <BadgeImage src={badge} {...props} />

export default FirstColumnBadgeBlocked
